import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './utils/leafletConfig';
import Router from './router/Router';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./shards-dashboard/styles/shards-dashboards.1.1.0.min.css";

import './i18n'


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router />
  </React.StrictMode>
);
